module.exports = __webpack_public_path__ + "img/gift3.a75a7daf.png";